"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_COURSES = 'LOAD_COURSES';
exports.LOAD_COURSE = 'LOAD_COURSE';
exports.CREATE_COURSE = 'CREATE_COURSE';
exports.UPDATE_COURSE = 'UPDATE_COURSE';
exports.PUBLISH_COURSE = 'PUBLISH_COURSE';
exports.UNPUBLISH_COURSE = 'UNPUBLISH_COURSE';
exports.ADD_COURSE_PERMISSION = 'ADD_COURSE_PERMISSION';
exports.SET_COURSE_ACCESSIBILITY = 'SET_COURSE_ACCESSIBILITY';
exports.SET_COURSE_ORGANIZATION = 'SET_COURSE_ORGANIZATION';
exports.ADD_COURSE_RELATION = 'ADD_COURSE_RELATION';
exports.REMOVE_COURSE_RELATION = 'REMOVE_COURSE_RELATION';
exports.LOAD_PUBLIC_COURSES = 'LOAD_PUBLIC_COURSES';
exports.LOAD_PUBLIC_COURSE = 'LOAD_PUBLIC_COURSE';
exports.LOAD_COURSEWORKS = 'LOAD_COURSEWORKS';
exports.LOAD_COURSEWORK = 'LOAD_COURSEWORK';
exports.CREATE_COURSEWORK = 'CREATE_COURSEWORK';
exports.UPDATE_COURSEWORK = 'UPDATE_COURSEWORK';
exports.SELECT_COURSEWORK = 'SELECT_COURSEWORK';
exports.PUBLISH_COURSEWORK = 'PUBLISH_COURSEWORK';
exports.UNPUBLISH_COURSEWORK = 'UNPUBLISH_COURSEWORK';
exports.ADD_COURSEWORK_PERMISSION = 'ADD_COURSEWORK_PERMISSION';
exports.SET_COURSEWORK_ACCESSIBILITY = 'SET_COURSEWORK_ACCESSIBILITY';
exports.SET_COURSEWORK_ORGANIZATION = 'SET_COURSEWORK_ORGANIZATION';
exports.ADD_COURSEWORK_RELATION = 'ADD_COURSEWORK_RELATION';
exports.REMOVE_COURSEWORK_RELATION = 'REMOVE_COURSEWORK_RELATION';
exports.LOAD_PUBLIC_COURSEWORKS = 'LOAD_PUBLIC_COURSEWORKS';
exports.LOAD_PUBLIC_COURSEWORK = 'LOAD_PUBLIC_COURSEWORK';
exports.LOAD_SUBMISSIONS = 'LOAD_SUBMISSIONS';
exports.LOAD_SUBMISSION = 'LOAD_SUBMISSION';
exports.CREATE_SUBMISSION = 'CREATE_SUBMISSION';
exports.UPDATE_SUBMISSION = 'UPDATE_SUBMISSION';
exports.PUBLISH_SUBMISSION = 'PUBLISH_SUBMISSION';
exports.UNPUBLISH_SUBMISSION = 'UNPUBLISH_SUBMISSION';
exports.ADD_SUBMISSION_PERMISSION = 'ADD_SUBMISSION_PERMISSION';
exports.SET_SUBMISSION_ACCESSIBILITY = 'SET_SUBMISSION_ACCESSIBILITY';
exports.SET_SUBMISSION_ORGANIZATION = 'SET_SUBMISSION_ORGANIZATION';
exports.ADD_SUBMISSION_RELATION = 'ADD_SUBMISSION_RELATION';
exports.REMOVE_SUBMISSION_RELATION = 'REMOVE_SUBMISSION_RELATION';
exports.LOAD_PUBLIC_SUBMISSIONS = 'LOAD_PUBLIC_SUBMISSIONS';
exports.LOAD_PUBLIC_SUBMISSION = 'LOAD_PUBLIC_SUBMISSION';
exports.LOAD_TOPICS = 'LOAD_TOPICS';
exports.LOAD_TOPIC = 'LOAD_TOPIC';
exports.CREATE_TOPIC = 'CREATE_TOPIC';
exports.UPDATE_TOPIC = 'UPDATE_TOPIC';
exports.PUBLISH_TOPIC = 'PUBLISH_TOPIC';
exports.UNPUBLISH_TOPIC = 'UNPUBLISH_TOPIC';
exports.ADD_TOPIC_PERMISSION = 'ADD_TOPIC_PERMISSION';
exports.SET_TOPIC_ACCESSIBILITY = 'SET_TOPIC_ACCESSIBILITY';
exports.SET_TOPIC_ORGANIZATION = 'SET_TOPIC_ORGANIZATION';
exports.ADD_TOPIC_RELATION = 'ADD_TOPIC_RELATION';
exports.REMOVE_TOPIC_RELATION = 'REMOVE_TOPIC_RELATION';
exports.LOAD_PUBLIC_TOPICS = 'LOAD_PUBLIC_TOPICS';
exports.LOAD_PUBLIC_TOPIC = 'LOAD_PUBLIC_TOPIC';
exports.LOAD_SUBJECTS = 'LOAD_SUBJECTS';
exports.LOAD_SUBJECT = 'LOAD_SUBJECT';
exports.CREATE_SUBJECT = 'CREATE_SUBJECT';
exports.UPDATE_SUBJECT = 'UPDATE_SUBJECT';
exports.PUBLISH_SUBJECT = 'PUBLISH_SUBJECT';
exports.UNPUBLISH_SUBJECT = 'UNPUBLISH_SUBJECT';
exports.ADD_SUBJECT_PERMISSION = 'ADD_SUBJECT_PERMISSION';
exports.SET_SUBJECT_ACCESSIBILITY = 'SET_SUBJECT_ACCESSIBILITY';
exports.SET_SUBJECT_ORGANIZATION = 'SET_SUBJECT_ORGANIZATION';
exports.ADD_SUBJECT_RELATION = 'ADD_SUBJECT_RELATION';
exports.REMOVE_SUBJECT_RELATION = 'REMOVE_SUBJECT_RELATION';
exports.LOAD_PUBLIC_SUBJECTS = 'LOAD_PUBLIC_SUBJECTS';
exports.LOAD_PUBLIC_SUBJECT = 'LOAD_PUBLIC_SUBJECT';
exports.LOAD_STUDENTS = 'LOAD_STUDENTS';
exports.LOAD_STUDENT = 'LOAD_STUDENT';
exports.CREATE_STUDENT = 'CREATE_STUDENT';
exports.UPDATE_STUDENT = 'UPDATE_STUDENT';
exports.ADD_STUDENT_PERMISSION = 'ADD_STUDENT_PERMISSION';
exports.SET_STUDENT_ACCESSIBILITY = 'SET_STUDENT_ACCESSIBILITY';
exports.SET_STUDENT_ORGANIZATION = 'SET_STUDENT_ORGANIZATION';
exports.ADD_STUDENT_RELATION = 'ADD_STUDENT_RELATION';
exports.REMOVE_STUDENT_RELATION = 'REMOVE_STUDENT_RELATION';
exports.LOAD_PUBLIC_STUDENTS = 'LOAD_PUBLIC_STUDENTS';
exports.LOAD_PUBLIC_STUDENT = 'LOAD_PUBLIC_STUDENT';